import { Buttons } from "@/components/atoms/Buttons";
import { TermText } from "@/components/atoms/TermText";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

interface TermDetailProps {
  title: string;
  text?: React.ReactElement;
}

export const TermsDetailPage = ({ title, text }: TermDetailProps) => {
  return (
    <MainTemplate
      nav={false}
      subPage={false}
      menuBtn={false}
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="뒤로"
          onClick={() => window.history.back()}
        />
      }
      pageTitle={title}
    >
      <TermText>
        <>{text}</>
      </TermText>
    </MainTemplate>
  );
};
